import {Backbone} from 'Vertebrae';
import {ProxiedGoogleLocationModel} from 'model/proxiedGoogleLocationModel';

export const ProxiedGoogleLocationCollection = Backbone.Collection.extend({
    _name : 'ProxiedGoogleLocationCollection',
    model : ProxiedGoogleLocationModel
});
